import { get, post, postGetBlob } from '../Services/http';
import { catchError } from './Error.action';

export const GENERIC_EXPORT_LOAD = 'GENERIC_EXPORT_LOAD';
export const GENERIC_EXPORT_LOAD_ERROR = 'GENERIC_EXPORT_LOAD_ERROR';
export const GENERIC_EXPORT_RECEIVE = 'GENERIC_EXPORT_RECEIVE';
export const GENERIC_EXPORT_STORE_TYPE = 'GENERIC_EXPORT_STORE_TYPE';
export const GENERIC_EXPORT_STORE_TYPE_INDEX = 'GENERIC_EXPORT_STORE_TYPE_INDEX';
export const GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS = 'GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS';

const rootRoute = '/api/genericExport/';
const genericLoaderId = 'genericLoader';

export const load = () => (dispatch, getState) => {
    
    const thisEl = document.getElementById("genericExport");
    const areatype = thisEl.dataset.areatype;
    dispatch(activateLoader());
    return post(rootRoute + 'getExportObjects', areatype)
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .then(dispatch(deactivateLoader()))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export const downloadPdf = (base64Str) => (dispatch, getState) => {
    const linkSource = `data:${contentType_Pdf};base64,${base64Str}`;
    const downloadLink = document.createElement("a");
    const fileName = "file.pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);

    downloadLink.click();
    downloadLink.remove();
}

const callPrint = (iframeId) => (dispatch, getState) => {
    var PDF = document.getElementById(iframeId);
    PDF.focus();
    PDF.contentWindow.print();
}

export const exportData = (exportType, method, responseType, exportObjectIndex) => (dispatch, getState) => {

    // Handle export differently reg to type expected.
    const exportObjects = [...getState().genericExport.exportObjects];
    const exportObject = exportObjects[exportObjectIndex];
    const customerExportObjects = [...exportObject.customerExportFields];
    const areaTypeName = getState().genericExport.areaTypeName;
    const saveCustomerFieldsCheckbox = document.getElementById('saveCustomerFields');
    let saveCustomerFields = false;

    dispatch(activateLoader());

    // If no custom fields are set: Show all
    // --------------------------------------
    if (!customerExportObjects.length) {
        exportObject.exportFields.map((exportField, fieldNameLeftIndex) => {
            let fieldData = {
                fieldDataLeft: {},
                fieldDeliminator: '',
                fieldDataRight: {},
                fieldHeading: exportField.exportObjectName,
            };

            fieldData.fieldDataLeft = {
                exportObjectId: exportField.exportObjectId,
                exportObjectName: exportField.exportObjectName,
                exportObjectType: exportField.exportObjectType,
                isBaseProduct: exportField.isBaseProduct,
                exportObjectImageWidth: '',
                exportObjectImageHeight: ''
            }
            customerExportObjects.push(fieldData);
        });
    } // Only save data if there are chosen fields...
    else if (saveCustomerFieldsCheckbox && saveCustomerFieldsCheckbox.checked) {
        saveCustomerFields = true;
    }
    const createObject = JSON.stringify({ exportType, method, responseType, areaTypeName, saveCustomerFields, customerExportFields: [...customerExportObjects] });

    exportType = exportType.toLowerCase();
    responseType = responseType.toLowerCase();

    switch (responseType) {
        case 'download':

            return post(rootRoute + 'exportData', createObject)
                .then(response => response.json())
                //.then(response => response.blob())
                .then(data => {
                    // TODO: For larger file sizes extend to use filestream.js
                    // TODO: CHECK IE compatibility!
                    var blob = b64toBlob(data.base64, data.contentType);
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);

                    link.download = data.fileName;
                    document.body.appendChild(link);
                    link.click();
                   
                    document.body.removeChild(link);
                    dispatch(deactivateLoader());
                })
                //.then(blob => {
                //    // use blob here...
                //    alert(blob);
                //})
                .then(data => dispatch(dataSent(data)))
                .then(setTimeout(data => dispatch(toggleExportDone(data)), 10000))
                .catch(ex => dispatch(catchError(ex, error => loadError(error))));

            //let mapForm = document.createElement("form");
            //mapForm.method = "POST";
            //mapForm.action = rootRoute + 'exportData2/' + createObject;
            //mapForm.style.display = "none";

            //// Create an input
            //let mapInput = document.createElement("input");
            //mapInput.type = "hidden";
            //mapInput.name = "currentObj";
            //mapInput.value = "hepp";

            //mapForm.appendChild(mapInput);

            //document.body.appendChild(mapForm);

            //setTimeout(function() {
            //    return mapForm.submit();
            //}, 10000);
            //return mapForm.submit();

            //return postGetBlob(rootRoute + 'exportData', createObject, null, 'application/x-www-form-urlencoded; charset=UTF-8')
            //    .then(response => response.json())
            //    .then(data => dispatch(handleDownload(data)))
            //    .then(data => dispatch(dataSent(data)))
            //    .then(setTimeout(data => dispatch(toggleExportDone(data)), 10000))
            //    .catch(ex => dispatch(catchError(ex, error => loadError(error))));

            //var data = JSON.stringify({
            //    currentObj: createObject
            //});
            //var request = new XMLHttpRequest();
            //request.open('POST', rootRoute + 'exportData', true);
            //request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            //request.responseType = 'blob';
            //request.send(data);
            //request.onload = function () {
            //    // Only handle status code 200
            //    if (request.status === 200) {
            //        // Try to find out the filename from the content disposition `filename` value
            //        var disposition = request.getResponseHeader('content-disposition');
            //        var matches = /"([^"]*)"/.exec(disposition);
            //        var filename = (matches != null && matches[1] ? matches[1] : 'file.' + exportType);

            //        // The actual download
            //        var blob = new Blob([request.response], { type: 'application/' + exportType });
            //        var link = document.createElement('a');
            //        link.href = window.URL.createObjectURL(blob);
            //        link.download = filename;

            //        document.body.appendChild(link);

            //        link.click();

            //        document.body.removeChild(link);
            //    }

            //    //todo fix error handling
            //};

            //request.send('content=' + content);
            break;

        default:
            dispatch(deactivateLoader());
            return null;
            break;
    }
}

export const activateLoader = () => (dispatch, getState) => {
    var loaderEl = document.getElementById(genericLoaderId);
    if (loaderEl) {
        loaderEl.classList.add("active");
    }
}

export const deactivateLoader = () => (dispatch, getState) => {
    var loaderEl = document.getElementById(genericLoaderId);
    if (loaderEl) {
        setTimeout(function () {
            loaderEl.classList.remove("active");
        }, 100);
    }
}

export const handleDownload = data => {
    //alert(data);
    return;
}

export const loadError = error => ({
    type: GENERIC_EXPORT_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = data => {

    return ({
        type: GENERIC_EXPORT_RECEIVE,
        payload: {
            exportObjects: data.exportObjects,
            areaTypeName: data.areaTypeName,
            //exportFieldItems: data.exportFieldItem.exportDataObject
        },
    });
}

export const setActiveExportType = (exportTypeName, activeObjectIndex) => (dispatch, getState) => {

    // Change Active Export Type
    dispatch(storeActiveExportType(exportTypeName));

    // Set active index
    dispatch(storeActiveObjectIndex(activeObjectIndex));
    //alert(activeObjectIndex);
    // Update 
    let exportObjects = [...getState().genericExport.exportObjects];

    const type = exportObjects[activeObjectIndex].exportFields[0] ? exportObjects[activeObjectIndex].exportFields[0].exportObjectType : null;

    exportObjects[activeObjectIndex] = { ...exportObjects[activeObjectIndex], activeFieldType: type };

    dispatch(storeUpdateExportObjects(exportObjects));
}



export const addFieldData = (fieldIdLeft, fieldDataLeft, fieldObjectTypeLeft, fieldDeliminator, fieldIdRight, fieldDataRight, fieldObjectTypeRight, fieldHeading, imageWidth, imageHeight, isBaseProductLeft, isBaseProductRight, exportFieldDescriptionLeft, exportFieldDescriptionRight, exportObjectIndex) => (dispatch, getState) => {

    let fieldData = {
        fieldDataLeft: {},
        fieldDeliminator,
        fieldDataRight: {},
        fieldHeading,
    };

    if (fieldDataLeft !== undefined && fieldDataLeft.length > 0) {
        fieldData.fieldDataLeft = {
            exportObjectId: fieldIdLeft,
            exportObjectName: fieldDataLeft,
            exportObjectType: fieldObjectTypeLeft,
            exportObjectImageWidth: imageWidth,
            exportObjectImageHeight: imageHeight,
            isBaseProduct: isBaseProductLeft,
            exportFieldDescription: exportFieldDescriptionLeft ? exportFieldDescriptionLeft : ""
        }
    }
    if (fieldDataRight !== undefined && fieldDataRight.length > 0) {
        fieldData.fieldDataRight = {
            exportObjectId: fieldIdRight,
            exportObjectName: fieldDataRight,
            exportObjectType: fieldObjectTypeRight,
            isBaseProduct: isBaseProductRight,
            exportFieldDescription: exportFieldDescriptionRight ? (fieldData.fieldDataLeft.exportFieldDescription.length > 0 ? " & " : "") + exportFieldDescriptionRight : ""
        }
    }

    //let exportObjects = deepCloneObject(getState().genericExport.exportObjects);
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[exportObjectIndex].customerExportFields.push(fieldData);
    return dispatch(storeUpdateExportObjects(exportObjects));
}

export const eraseAllFieldData = (exportObjectIndex) => (dispatch, getState) => {
    //let exportObjects = deepCloneObject(getState().genericExport.exportObjects);
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[exportObjectIndex].customerExportFields = [];
    dispatch(storeUpdateExportObjects(exportObjects));
}

export const removeFieldData = (exportObjectIndex, fieldIndex) => (dispatch, getState) => {
    //let exportObjects = deepCloneObject(getState().genericExport.exportObjects);
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[exportObjectIndex].customerExportFields.splice(fieldIndex, 1);
    dispatch(storeUpdateExportObjects(exportObjects));
}

export const changeActiveFieldType = (objectIndex, type) => (dispatch, getState) => {
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[objectIndex] = { ...exportObjects[objectIndex], activeFieldType: type };
    dispatch(storeUpdateExportObjects(exportObjects));
}


export const storeActiveExportType = exportType => {
    return ({
        type: GENERIC_EXPORT_STORE_TYPE,
        payload: {
            activeType: exportType,
        },
    });
}

export const storeActiveObjectIndex = activeObjectIndex => {
    return ({
        type: GENERIC_EXPORT_STORE_TYPE_INDEX,
        payload: {
            activeObjectIndex,
        },
    });
}


export const storeUpdateExportObjects = exportObjects => {
    return ({
        type: GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS,
        payload: {
            exportObjects,
        },
    });
}

export const toggleExportDone = data => {

    return ({
        type: GENERIC_EXPORT_RECEIVE,
        payload: {
            exportDone: false,
        },
    });
}

export const dataSent = data => {

    return ({
        type: GENERIC_EXPORT_RECEIVE,
        payload: {
            exportDone: true,
        },
    });
}

function deepCloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}